import React, {useContext} from "react"
import {UnauthenticatedUser, UserContext} from "../../services/authentication/user-context"
import {Redirect} from "react-router-dom"
import {Page} from "../../components-shared/page/page"
import {SignUp} from "./sign-up"

export const SignUpPage: React.FC = () => {
  const user = useContext(UserContext)

  if (user !== UnauthenticatedUser) {
    return <Redirect to="/" />
  }

  return <Page title="Account maken">
    <SignUp/>
  </Page>
}